import api from './api';

const jobRoleService = {
    /**
     * Get all active job roles (public endpoint - no auth required)
     */
    getPublicJobRoles: async () => {
        const response = await api.get('/job-roles/public');
        return response.data;
    }
};

export default jobRoleService;
